import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Calculator } from './components/Calculator';
import { CommercialTable } from './components/CommercialTable';
import { FAQ, Footer } from './components/Sections';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-blue-200" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Calculator data-id="element-4" />
        <CommercialTable data-id="element-5" />
        <FAQ data-id="element-6" />
      </main>

      <Footer data-id="element-7" />

      {/* Floating WhatsApp Button */}
      <a href="https://wa.me/5491122696510" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-400 text-white p-4 rounded-full shadow-2xl hover:shadow-green-500/30 transition-all hover:scale-110 flex items-center justify-center group" aria-label="Contactar por WhatsApp" data-id="element-8">
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7" data-id="element-9">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-10"></path>
        </svg>
        {/* Tooltip */}
        <span className="absolute right-full mr-4 bg-white text-gray-900 text-sm font-bold py-2 px-3 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap border border-gray-100" data-id="element-11">
          11 2269-6510
        </span>
      </a>
    </div>;
}